module.exports = __webpack_public_path__ + "img/ganghaolai-mall-feedback.be7e02c3.png";